module.exports = __webpack_public_path__ + "img/ok.e124b79d.svg";